import React from 'react';
import c from 'classnames';
import isFunction from 'lodash/isFunction';

import { BaseMenuItem, BaseMenuList, Divider, Typography } from '@lyearn/ui';

import { iconStyle, menuItemSelectedStyle } from './style';
import { BlockMenuItemType, BlockMenuListProps } from './types';

const BlockMenuList: React.FC<BlockMenuListProps> = (props) => {
  const { open, anchorEl, view, menuItems } = props;

  return (
    <BaseMenuList autoFocus={true} className="w-192 p-10 outline-none">
      {menuItems
        .filter((menuItem) => menuItem.isEnabled(open, anchorEl, view))
        .map((menuItem: BlockMenuItemType, index: number) => {
          return menuItem.divider ? (
            <Divider key={index} className="m-4" />
          ) : (
            <BaseMenuItem
              key={index}
              className={c(
                'my-2 flex h-40 items-center justify-between rounded-8 p-10 hover:bg-s-info-light',
                menuItemSelectedStyle,
              )}
              data-id={
                isFunction(menuItem.title) ? menuItem.title(open, anchorEl, view) : menuItem.title
              }
              onClick={() => menuItem?.onItemClick?.(open, anchorEl, view)}>
              <Typography
                className={c(menuItem.color ? menuItem.color : 'text-text-secondary')}
                variant="body-short-02">
                {isFunction(menuItem.title) ? menuItem.title(open, anchorEl, view) : menuItem.title}
              </Typography>
              {menuItem.icon && (
                <menuItem.icon
                  className={c(
                    'fill-current',
                    iconStyle,
                    menuItem.color ? menuItem.color : 'text-icon-secondary',
                  )}
                />
              )}
            </BaseMenuItem>
          );
        })}
    </BaseMenuList>
  );
};

export default React.memo(BlockMenuList);
